import React from "react"
import Wrapper from "@components/Wrapper"
import WrapperInner from "@components/WrapperInner"
import styles from "./Footer.module.scss"
import Facebook from "./facebook-square.svg"
import LinkedIn from "./linkedin.svg"
import Twitter from "./twitter-square.svg"
import Logo from "@images/logo.png"
import { Link } from "gatsby"
import { OutboundLink } from "@assertiv/assertiv-gatsby-plugin-google-gtag"
import { PopupWidget } from "react-calendly";

const Footer = props => {
  const currentDate = new Date()

  return (
    <section className={styles.section + " container-fluid bg-primary"}>
      <div className="row ml-0 mr-0">
        <Wrapper className="w-100" gap="outer">
          <WrapperInner className={"row"}>
            <div className="col-12 col-lg-3 text-center text-lg-left">
              <Link to="/">
                <img
                  className={styles.logo + " mb-10 mb-lg-0"}
                  src={Logo}
                  alt="EngineID Home"
                />
              </Link>
            </div>

            <div
              className={
                styles.iconGroup +
                " col-12 col-lg-3 col-xl-2 d-flex justify-content-center justify-content-lg-start mb-10 mb-lg-0"
              }
            >
              <OutboundLink target="_blank" href="https://www.linkedin.com/company/engineid/about/">
                <img src={LinkedIn} alt="EngineID's LinkedIn Page" />
              </OutboundLink>
              <OutboundLink target="_blank" href="https://www.facebook.com/engineidplatform/">
                <img src={Facebook} alt="EngineID's Facebook Page" />
              </OutboundLink>
              <OutboundLink target="_blank" href="https://twitter.com/engineidtech/">
                <img src={Twitter} alt="EngineID's Twitter Page" />
              </OutboundLink>
            </div>
            <div className="col-12 col-lg-6 col-xl-7 d-flex flex-column flex-xl-row justify-content-between text-center text-lg-right">
              <div className="proxima-nova--light mb-5 mb-xl-0 fs-14pt">
                <Link to="/privacy-policy" className="d-inline-block">
                  Privacy policy
                </Link>
                <span className={styles.divider}>&nbsp;|&nbsp;</span>
                <Link to="/terms-and-conditions" className="d-inline-block">
                  Terms & Conditions
                </Link>
              </div>
              <p className="text-white fs-12pt fs-lg-14pt ls-2px">
                <span className="d-inline-block">
                  COPYRIGHT &#169; {currentDate.getFullYear()}&nbsp;
                </span>
                <span className="d-inline-block">ALL RIGHTS RESERVED.</span>
              </p>
            </div>
          </WrapperInner>
        </Wrapper>
      </div>
      <div className="App">
        <PopupWidget color="#0d0f38" text="Schedule a Demo or Introduction with EngineID" url="https://calendly.com/engineiddemo" />
      </div>
    </section>
  )
}

export default Footer
